<template>
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label>Status</label>
        <select-component
          name="cod_status"
          ref="statusSelect"
          @change="onChangeStatus"
          v-model="status"
        >
          <option value>Todos</option>
          <option
            v-for="(status, index) of statuses"
            :key="index"
            :value="status.id_status"
          >{{ status.ds_status }}</option>
        </select-component>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>Substatus</label>
        <select-component
          name="cod_substatus"
          ref="substatusSelect"
          @change="onChangeSubstatus"
          v-model="substatus"
        >
          <option value>{{ status ? 'Todos' : 'Selecione primeiro o status'}}</option>
          <option
            v-for="(substatus, index) of substatuses"
            :key="index"
            :value="substatus.id_substatus"
          >{{ substatus.ds_substatus }}</option>
        </select-component>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    codSubstatus: {
      default: ""
    },
    codStatus: {
      default: ""
    }
  },
  data: () => ({
    status: "",
    substatus: "",
    statuses: [],
    substatuses: []
  }),
  methods: {
    onChangeStatus(val) {
      this.status = val;

      this.substatus = "";
      this.substatuses = [];

      if (val) {
        axios
          .get("/sidagro/relatorio-propriedades-com-status/get-substatuses", {
            params: {
              idStatus: val
            }
          })
          .then(res => res.data)
          .then(res => {
            this.substatuses = res;
            setTimeout(() => {
              this.$refs.substatusSelect.generateOptions();

              if (this.codSubstatus) {
                this.onChangeSubstatus(this.codSubstatus);
              }
            }, 0);
          });
      } else {
        setTimeout(() => {
          this.$refs.substatusSelect.generateOptions();
        }, 0);
      }
    },
    onChangeSubstatus(val) {
      this.substatus = val;
    }
  },
  beforeMount() {
    axios
      .get("/sidagro/relatorio-propriedades-com-status/get-statuses")
      .then(res => res.data)
      .then(res => {
        this.statuses = res;
        setTimeout(() => {
          this.$refs.statusSelect.generateOptions();

          if (this.codStatus) {
            this.onChangeStatus(this.codStatus);
          }
        }, 500);
      });
  }
};
</script>
